import http from '../../../utils/fetch';
export default {
    query(v) {
        return http({
            url: '/api/bscUserInfoAgentBasic/selectAgentList',
            method: 'post',
            params: v
        });
    },
    orders(usercode,currency,saleGroupCode) {
        return http({
            url: '/api/swyl/v1/dingdmain/selectListByClaim',
            method: 'post',
            params: {usercode,currency,saleGroupCode}
        });
    },
    selectVoucher(userReceForeignId) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/selectVoucher',
            method: 'post',
            params: {userReceForeignId}
        });
    },
    claim(entity) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/claim',
            method: 'post',
            data: entity
        });
    },
    claimAgain(entity) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/claimAgain',
            method: 'post',
            data: entity
        });
    },
    trim(entity) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/trim',
            method: 'post',
            data: entity
        });
    },
    orderProcessPage(entity) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/orderProcessPage',
            method: 'post',
            data: entity
        });
    },
    getClaimedOrders(entity) {
        return http({
            url: '/api/swyl/v1/demo/orderMainZc/selectClaimdList',
            method: 'post',
            params: entity
        });
    },
    getClaimedApproveOrders(entity) {
        return http({
            url: '/api/swyl/v1/demo/orderMainZc/selectClaimdApprovedList',
            method: 'post',
            params: entity
        });
    },
    selectTrimList(entity) {
        return http({
            url: '/api/swyl/v1/demo/orderMainZc/selectTrimList',
            method: 'post',
            params: entity
        });
    },
    getDomesticToOrder(belnr) {
        return http({
            url: '/api/swyl/v1/demo/userReceDomesticToOrder/getDomesticToOrder',
            method: 'post',
            params: {belnr}
        });
    },
}
